/**
 * Fragment de routes du paquet v11-p01-journal-audit (vague V11, règle R2 du découpage V4–V11 : un fragment par paquet, le
 * fichier `v11.tsx` de la vague n'est écrit par personne). Composants chargés à la demande, aucun code exécuté au
 * chargement. Routes neuves, aucune route du socle remplacée :
 *  - `/projet/journal?projet=…&<filtres>` → projet-journal-audit ;
 *  - `/projet/journal/evenement?projet=…&evenement=<source>:<ref>&retour=…` → projet-evenement-fiche ;
 *  - `/projet/journal/exporter?projet=…&<filtres>` → dialogue-exporter-journal.
 */
import { lazy, Suspense, type ComponentType, type JSX } from 'react'

import type { Session } from '../../auth/session'
import type { ContexteRoutes, FragmentRoutes } from './registre'

const ProjetJournalAudit = lazy(() => import('../ecrans/v11/journal/ProjetJournalAudit'))
const ProjetEvenementFiche = lazy(() => import('../ecrans/v11/journal/ProjetEvenementFiche'))
const DialogueExporterJournal = lazy(() => import('../ecrans/v11/journal/DialogueExporterJournal'))

function ecran(Composant: ComponentType<{ session: Session }>) {
  return ({ session, t }: ContexteRoutes): JSX.Element => (
    <Suspense fallback={<p role="status">{t('v10.primitives.assemblage.chargement')}</p>}>
      <Composant session={session} />
    </Suspense>
  )
}

export const fragment: FragmentRoutes = {
  zone: 'v11-journal',
  routes: [
    { chemin: '/projet/journal', element: ecran(ProjetJournalAudit) },
    { chemin: '/projet/journal/evenement', element: ecran(ProjetEvenementFiche) },
    { chemin: '/projet/journal/exporter', element: ecran(DialogueExporterJournal) },
  ],
}
